import styles from "./SharePage.module.css";
import { linksvg, copylinksvg } from "../../assets/svg/svgimages";
import { socials } from "../../assets/svg/socialicons";
import React, { useState } from "react";
import { capture } from "../../analytics";

const checkmarkSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-check"
    viewBox="0 0 24 24"
  >
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const SharePage = ({ profile, productSlug, productTitle }) => {
  const [copied, setCopied] = useState(false);

  const linkToCopy = `https://grids.matchmovemachine.com/library/product/${productSlug}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      setCopied(true);
      capture("share_clicked", {
        method: "copy_link",
        product_slug: productSlug,
        product_title: productTitle,
      });
      // Через 10 секунд вернуть кнопку обратно
      setTimeout(() => {
        setCopied(false);
      }, 10000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleSocialClick = (event, link, platform) => {
    if (!link) {
      event.preventDefault();
      return;
    }
    capture("share_clicked", {
      method: "social",
      platform,
      product_slug: productSlug,
      product_title: productTitle,
    });
  };

  return (
    <div className={`width ${styles.bottom}`}>
      <h2 className="h2-medium">Share this page</h2>
      <div className={styles.container}>
        <div className={styles.content}>
          <h4 className="h4-medium">{linksvg} Link</h4>
          <div className={styles.link}>
            <div className={styles.inputcont}>
              <button
                className={`${styles.copybtn} ${copied ? styles.copied : ""}`}
                onClick={copyToClipboard}
                disabled={copied}
                aria-label={copied ? "Copied" : "Copy link"}
              >
                {/* Плавный переход через CSS */}
                <span
                  className={`${styles.icon} ${copied ? styles.iconHidden : ""}`}
                  aria-hidden="true"
                >
                  {copylinksvg}
                </span>
                <span
                  className={`${styles.icon} ${copied ? styles.iconVisible : styles.iconHidden}`}
                  aria-hidden="true"
                >
                  {checkmarkSvg}
                </span>
              </button>
              <div className={styles.input}>{linkToCopy}</div>
            </div>
          </div>
          <div className={styles.socials}>
            {socials.map((item) => {
              const shareUrl = linkToCopy;
              const shareText = productTitle || `Check out this product!`;
              const link =
                {
                  facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                  twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
                  linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
                  instagram: `https://www.instagram.com/`,
                  reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareText)}`,
                }[item.key] || "";

              return (
                <a
                  key={item.id}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleSocialClick(e, link, item.key)}
                >
                  <button className={styles.socialbtn}>
                    {item.icon} <p>{item.name}</p>
                  </button>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharePage;
